import { render } from "./PdfDataTable.vue?vue&type=template&id=d30161d2&scoped=true&ts=true"
import script from "./PdfDataTable.vue?vue&type=script&lang=ts"
export * from "./PdfDataTable.vue?vue&type=script&lang=ts"

import "./PdfDataTable.vue?vue&type=style&index=0&id=d30161d2&scoped=true&lang=scss"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d30161d2"]])

export default __exports__